// Custom hook to track page views with Google Tag

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const pagePath = window.location.hash.replace("#", "") || "/";

    window.gtag("event", "page_view", {
      send_to: "AW-18068579668",
      page_path: pagePath,
    });
  }, [location]);
}
